import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError, change, initialize } from 'redux-form';
import moment from 'moment';
import { ROOT_URL } from '../../../../../actions/root_url';

const processDrivers = (drivers = []) => {
  return drivers.map(driver => ({
    label: `${driver.first_name || ''} ${driver.last_name || ''}`,
    value: driver.id,
  }))
}
export const fetchDrivers = (callback) => {
  axios({
    method: 'GET',
    url: `${ROOT_URL}v1/baseuser/driver/`,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  })
  .then(res => {
    callback( processDrivers(res.data));
  }, err => {
    alert(err);
  })
}
export const assignOrdersToDriver = (data, success, type) => {
  axios({
    method: 'PUT',
    url: `${ROOT_URL}v1/sale/sales-order-assign-driver/${type}`,
    data,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  })
  .then(res => {
    success();
  }, () => {

  })
}



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/driverList/redux.jsx